import type { RootState } from '@app/types';

export const getDownloadExportLoading = (state: RootState) => state.downloadExport.loading;

export const getDownloadExportError = (state: RootState) => state.downloadExport.error;
